export default __webpack_public_path__ + "static/media/logo-splash.2b9ee85d.png";